(function($) {

	$.fn.msxijqgrid = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxijqgrid.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            //Attache the jqx grid
            var source =
            {
                datatype: eOpts['datatype'],
                updaterow: eOpts['updaterow'],
                datafields: eOpts['datafields'],
                updaterow: eOpts['updaterow'],
                unboundmode: true,
                url: eOpts['url'],
                data: {
                    featureClass: "P",
                    style: "full",
                    maxRows: 50
                }
            };
            var $jqxGrid = $this.find(".jqxInnerDiv");
            var dataAdapter = new $.jqx.dataAdapter(source);
            $jqxGrid.jqxGrid(
            {
                width: eOpts['width'],
                source: dataAdapter,
                theme: 'overcast',
                editable: eOpts['editable'],
                selectionmode: eOpts['selectionmode'],
                enablehover: eOpts['enablehover'],
                sortable: eOpts['sortable'],
                editmode: eOpts['editmode'],
                filterable: eOpts['filterable'],
                pageable: eOpts['pageable'],
                selectionmode: 'multiplecellsadvanced',
                columnsresize: true,
                columns: eOpts['columns'],
                autorowheight: eOpts['autorowheight'],
                autoheight: eOpts['autoheight'],
                showstatusbar: eOpts['showstatusbar'],
                renderstatusbar: eOpts['renderstatusbar'],
                altrows: eOpts['altrows: '],
                showemptyrow: eOpts['showemptyrow']

            });
            $jqxGrid.on("bindingcomplete", function() {
                $jqxGrid.jqxGrid('autoresizecolumns');
            });


        });

	};
	//
	// plugin defaults
	//
	$.fn.msxijqgrid.defaults = {
        'width': '100%',
		'datafields': [],
		'columns': [],
        'editable': false,
        'updaterow': function(rowid, rowdata, commit){},
        'datatype': 'json',
        selectionmode: 'none',
        enablehover: false,
        'sortable': true,
        'filterable': true,
        'editmode': 'dblclick',
        pageable: true,
        altrows: true,
        'url': '',
        autorowheight: true,
        autoheight: true,
        showstatusbar: false,
        renderstatusbar: function (statusbar){},
        altrows: true,
        showemptyrow: true
	};

})(jQuery);